import React, { Component } from "react";
import axios from "axios";
import { Container, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HOSTURL, BOOTH_AUTH_API } from "../../constants/Constants";
import Modal from "react-bootstrap/Modal";
import Cookies from "js-cookie";
require("./Authenticate.scss");

class Authenticate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      showModal: false,
      authenticate: false,
      authenticateId: null,
      user: null
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleVerifyCode = this.handleVerifyCode.bind(this);
  }

  handleAuthenticate(e) {
    this.setState({ authenticateId: e.target.value });
  }

  isValidEmail(value) {
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(value);
  }

  isValidPhoneNumber(value) {
    const regexp = /^\d{10}$/;
    return regexp.test(value);
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let id = this.state.authenticateId;
    let url = '';

    if (this.isValidEmail(id)) {
      url = HOSTURL + BOOTH_AUTH_API + "email/" + id;
    } else if (this.isValidPhoneNumber(id)) {
      url = HOSTURL + BOOTH_AUTH_API + "contact/" + id;
    }
    this.setState({ showModal: true });
    axios.get(url).then(response => {
      console.log(response.data);
      this.setState({ user: response.data });
    });
    
  }

  handleVerifyCode(e) {
    if (this.state.user.authenticationCode === Number(e.target.value)) {
      //console.log("authentication code match");
      this.setState({ pathname: "/home" });
      Cookies.set("boothUserId", this.state.user.boothUserId, {
        expires: 8
      });
      Cookies.set("boothId", this.state.user.boothId, {
        expires: 8
      });
    }
  }

  render() {
    return (
      <Container className="auth-container">
        <Modal show={this.state.showModal}>
          <Modal.Header>
            <Modal.Title>Verify your details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="verification-modal-text">
              Enter the authentication code sent to: {this.state.emailAddress}
            </div>
            <Form.Control type="text" onChange={this.handleVerifyCode} />
          </Modal.Body>
          <Modal.Footer>
            <Link
              to={{
                pathname: this.state.pathname,
                state: this.state
              }}
            >
              <Button variant="primary">Confirm</Button>
            </Link>
          </Modal.Footer>
        </Modal>
        <div className="title">Resonate Booth</div>
        <div className="input-group">
          <div className="input-fields">
            <Form.Control
              className="number"
              type="text"
              onChange={this.handleAuthenticate}
              placeholder="Enter Your Email Address or Mobile Number"
              value={this.state.authenticateId}
            />
            <Button className="button" onClick={this.handleFormSubmit}>
              Submit
            </Button>
          </div>
        </div>
      </Container>
    );
  }
}

export default Authenticate;
